import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { LoadError, errMessage } from "@/components/LoadError";

const Punt = ({ p }) => (typeof p === "string" ? <li className="text-sm text-zinc-800 leading-relaxed">{p}</li> : (
  <li className="text-sm text-zinc-800 leading-relaxed">
    {p.tekst}
    <ul className="mt-1.5 ml-4 space-y-1.5 list-disc marker:text-zinc-400">{p.sub.map((s) => <li key={s} className={/^\d+\. /.test(s) ? "list-none -ml-4" : ""}>{s}</li>)}</ul>
  </li>
));

function Deel({ deel }) {
  return (
    <div data-testid={`handleiding-deel-${deel.rol}`} className="space-y-5">
      {deel.secties.map((s) => (
        <section key={s.titel} className="bg-white border border-zinc-200 rounded-[10px] p-4">
          <h2 className="font-heading font-black text-lg text-zinc-900 mb-2">{s.titel}</h2>
          <ul className="space-y-2.5 list-disc ml-5 marker:text-zinc-400">{s.punten.map((p, i) => <Punt key={i} p={p} />)}</ul>
        </section>
      ))}
    </div>
  );
}

export default function Handleiding() {
  const [d, setD] = useState(null);
  const [err, setErr] = useState("");
  const [tab, setTab] = useState(null);
  const [tick, setTick] = useState(0);
  useEffect(() => {
    let alive = true;
    setErr("");
    api.get("/handleiding").then((r) => { if (alive) { setD(r.data); setTab((t) => t || (r.data.delen.some((x) => x.rol === r.data.eigen) ? r.data.eigen : r.data.delen[0].rol)); } })
      .catch((e) => alive && setErr(errMessage(e)));
    return () => { alive = false; };
  }, [tick]);
  const actief = d?.delen.find((x) => x.rol === tab) || d?.delen[0];
  const onTabKey = (e, i) => {
    const n = d.delen.length;
    const nieuw = e.key === "ArrowRight" ? (i + 1) % n : e.key === "ArrowLeft" ? (i - 1 + n) % n : e.key === "Home" ? 0 : e.key === "End" ? n - 1 : null;
    if (nieuw === null) return;
    e.preventDefault();
    setTab(d.delen[nieuw].rol);
    document.getElementById(`handleiding-tab-${d.delen[nieuw].rol}`)?.focus();
  };
  return (
    <div data-testid="handleiding-page" className="max-w-3xl">
      <h1 className="font-heading text-2xl font-black tracking-tight text-zinc-900">Handleiding</h1>
      <p className="text-sm text-zinc-500 mb-4">Per rol: wie vult wat in, en wie ziet wat.</p>
      <LoadError error={err} onRetry={() => setTick((t) => t + 1)} testid="handleiding-load-error" />
      {!d && !err && <p className="text-sm text-zinc-400">Laden…</p>}
      {d && d.delen.length > 1 && (
        <div role="tablist" aria-label="Handleiding per rol" className="flex gap-1 mb-4 rounded-md border border-zinc-300 bg-white p-0.5 w-fit" data-testid="handleiding-tabs">
          {d.delen.map((x, i) => (
            <button key={x.rol} id={`handleiding-tab-${x.rol}`} role="tab" aria-selected={tab === x.rol} aria-controls={`handleiding-paneel-${x.rol}`} tabIndex={tab === x.rol ? 0 : -1}
              data-testid={`handleiding-tab-${x.rol}`} onClick={() => setTab(x.rol)} onKeyDown={(e) => onTabKey(e, i)}
              className={`px-3 py-1.5 min-h-[44px] sm:min-h-0 rounded-sm text-sm font-semibold transition-colors ${tab === x.rol ? "bg-zinc-950 text-white" : "text-zinc-500 hover:bg-zinc-100"}`}>{x.titel}</button>
          ))}
        </div>
      )}
      {actief && <div role={d.delen.length > 1 ? "tabpanel" : undefined} id={`handleiding-paneel-${actief.rol}`} aria-labelledby={d.delen.length > 1 ? `handleiding-tab-${actief.rol}` : undefined}><Deel deel={actief} /></div>}
    </div>
  );
}
